import * as StudentConstants from "../constants/student.constant";
import { Loading } from "../utils/helpers/constants";

const initialState = {
  userData: {},
  activateUserLoading: "",
  studentProfile: {},
  studentProfileLoading: "",
  studentAddresses: [],
  studentAchievements: [],
  projectsCompleted: [],
  projectsInProgress: [],
  people: [],
  peopleLoading: false,
  fileUploadLoading: "",
  studentList: [],
  studentListLoading: "",
  deleteStatusState: false,
  message: "",
  memberLoading: "",
  members: [],
  paymentModal: false,
  paymentMessage: "",
  chatUsersInfo: [],
  chatUsersInfoLoading: false,
};

const studentReducer = (state = initialState, action) => {
  switch (action.type) {
    case StudentConstants.ACTIVATE_USER_REQUEST:
      return { ...state, activateUserLoading: Loading.FETCHING };

    case StudentConstants.ACTIVATE_USER_SUCCESS:
      return {
        ...state,
        activateUserLoading: Loading.SUCCESS,
      };

    case StudentConstants.ACTIVATE_USER_FAILURE:
      return { ...state, activateUserLoading: Loading.ERROR };

    case StudentConstants.FETCH_ALL_STUDENT_REQUEST:
      return { ...state, studentListLoading: Loading.FETCHING };

    case StudentConstants.FETCH_ALL_STUDENT_SUCCESS:
      return {
        ...state,
        studentList: action.payload.students,
        studentListLoading: Loading.SUCCESS,
      };
    case StudentConstants.FETCH_ALL_STUDENT_FAILURE:
      return { ...state, studentListLoading: Loading.ERROR };

    case StudentConstants.FETCH_STUDENT_YEAR_REQUEST:
      return { ...state, studentListLoading: Loading.FETCHING };

    case StudentConstants.FETCH_STUDENT_YEAR_SUCCESS:
      return {
        ...state,
        studentList: action.payload.students,
        studentListLoading: Loading.SUCCESS,
      };
    case StudentConstants.FETCH_STUDENT_YEAR_FAILURE:
      return { ...state, studentListLoading: Loading.ERROR };

    case StudentConstants.FETCH_STUDENT_PROGRAM_REQUEST:
      return { ...state, studentListLoading: Loading.FETCHING };

    case StudentConstants.FETCH_STUDENT_PROGRAM_SUCCESS:
      return {
        ...state,
        studentList: action.payload.students,
        studentListLoading: Loading.SUCCESS,
      };
    case StudentConstants.FETCH_STUDENT_PROGRAM_FAILURE:
      return { ...state, studentListLoading: Loading.ERROR };

    case StudentConstants.FETCH_STUDENT_INFO_REQUEST:
      return { ...state, activateUserLoading: Loading.FETCHING };

    case StudentConstants.FETCH_STUDENT_INFO_SUCCESS:
      return {
        ...state,
        userData: action.payload,
        activateUserLoading: Loading.SUCCESS,
      };
    case StudentConstants.FETCH_STUDENT_INFO_FAILURE:
      return { ...state, activateUserLoading: Loading.ERROR };

    case StudentConstants.FETCH_STUDENT_PROFILE_REQUEST:
      return { ...state, studentProfileLoading: Loading.FETCHING };

    case StudentConstants.FETCH_STUDENT_PROFILE_SUCCESS:
      return {
        ...state,
        studentProfile: action.payload,
        studentAddresses: action.payload.addresses,
        studentAchievements: action.payload.achievements,
        studentProfileLoading: Loading.SUCCESS,
      };

    case StudentConstants.FETCH_STUDENT_PROFILE_FAILURE:
      return { ...state, studentProfileLoading: Loading.ERROR };

    case StudentConstants.FETCH_PEOPLE_YOU_MAY_KNOW_REQUEST:
      return { ...state, peopleLoading: Loading.FETCHING };

    case StudentConstants.FETCH_PEOPLE_YOU_MAY_KNOW_SUCCESS:
      return {
        ...state,
        peopleLoading: Loading.SUCCESS,
        people: action.payload,
      };
    case StudentConstants.FETCH_PEOPLE_YOU_MAY_KNOW_FAILURE:
      return { ...state, peopleLoading: Loading.ERROR };

    case StudentConstants.UPLOAD_STUDENT_FILE_REQUEST:
      return { ...state, fileUploadLoading: Loading.FETCHING };

    case StudentConstants.UPLOAD_STUDENT_FILE_SUCCESS:
      return {
        ...state,
        fileUploadLoading: Loading.SUCCESS,
        message: action.payload.message,
      };
    case StudentConstants.UPLOAD_STUDENT_FILE_FAILURE:
      return { ...state, fileUploadLoading: Loading.ERROR };

    case StudentConstants.FETCH_ALL_MEMBER_REQUEST:
      return { ...state, memberLoading: Loading.FETCHING };

    case StudentConstants.FETCH_ALL_MEMBER_SUCCESS:
      return {
        ...state,
        memberLoading: Loading.SUCCESS,
        members: action.payload.studentList,
      };
    case StudentConstants.FETCH_ALL_MEMBER_FAILURE:
      return { ...state, memberLoading: Loading.ERROR };
    case StudentConstants.ACTIVATE_PAYMENT_MODAL:
      return {
        ...state,
        paymentModal: true,
        paymentMessage: action.payload.message,
      };

    case StudentConstants.FETCH_STUDENTS_BY_MATRIC_REQUEST:
      return { ...state, chatUsersInfoLoading: true };

    case StudentConstants.FETCH_STUDENTS_BY_MATRIC_SUCCESS:
      console.log("action.payload ", action.payload);
      return {
        ...state,
        chatUsersInfo: action.payload.data,
        chatUsersInfoLoading: true,
      };

    case StudentConstants.FETCH_STUDENTS_BY_MATRIC_FAILURE:
      return { ...state, chatUsersInfoLoading: false };

      case StudentConstants.FETCH_STUDENT_LASTNAME_REQUEST:
      return { ...state, studentListLoading: Loading.FETCHING };

    case StudentConstants.FETCH_STUDENT_LASTNAME_SUCCESS:
      return {
        ...state,
        studentList: action.payload.students,
        studentListLoading: Loading.SUCCESS,
      };
    case StudentConstants.FETCH_STUDENT_LASTNAME_FAILURE:
      return { ...state, studentListLoading: Loading.ERROR };
      
    default:
      return state;
  }
};

export default studentReducer;
